import { render, staticRenderFns } from "./LyricistEdit.vue?vue&type=template&id=795029a7&"
import script from "./LyricistEdit.vue?vue&type=script&lang=js&"
export * from "./LyricistEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports